import React, { ReactNode } from "react";
import TableColumn from "./tableColumn";
import "../../assets/styles/components/table.scss";
import parse from "html-react-parser";

interface Props {
  children: ReactNode;
  width?: string;
  fixed?: boolean;
  header: {
    title: string;
    align?: string;
    width?: string;
    colspan?: number;
    rowspan?: number;
  }[];
  subHeader?: {
    title: string;
    align?: string;
    colspan?: number;
    rowspan?: number;
  }[];
  headerPadding?: string;
}

const MainTable: React.FC<Props> = ({
  children,
  width = "100%",
  header,
  subHeader,
  fixed = false,
  headerPadding,
}) => {
  return (
    <div className="table-main">
      <table width={width} className={fixed ? `fixed` : ``}>
        <thead>
          <tr className="thead">
            {header.map((item, index) => (
              <TableColumn
                align={item.align}
                colspan={item.colspan}
                rowspan={item.rowspan}
                width={item?.width}
                key={index}
                padding={headerPadding}
              >
                {parse(item.title)}
              </TableColumn>
            ))}
            {/* {subHeader === undefined ? <td width="0px"></td> : <tr></tr>} */}
            {/* <tr>
              {subHeader?.map((item, index) => (
                <TableColumn
                  align={item.align}
                  colspan={item.colspan}
                  rowspan={item.rowspan}
                  key={index}
                >
                  {item.title}
                </TableColumn>
              ))}
            </tr> */}
          </tr>
          {subHeader !== undefined ? (
            <tr className="thead">
              {subHeader?.map((item, index) => (
                <TableColumn
                  align={item.align}
                  colspan={item.colspan}
                  rowspan={item.rowspan}
                  key={index}
                >
                  {parse(item.title)}
                </TableColumn>
              ))}
            </tr>
          ) : (
            <></>
            // <tr style={{ height: "0px" }}></tr>
          )}
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default MainTable;
